import { action } from 'typesafe-actions';
import { IApiQueryOptions } from 'api/ApiClient';
import { IApiList, IEmployeePayrollTip } from 'types';
import { EmployeePayrollTips } from './types';

export const getEmployeePayrollTipsRequest = (siteId: string, startDate: string, endDate: string, options?: IApiQueryOptions) => action(EmployeePayrollTips.GET_EMPLOYEE_PAYROLL_TIPS_REQUEST, { siteId, startDate, endDate, options });
export const getEmployeePayrollTipsSuccess = (response: IApiList<IEmployeePayrollTip>) => action(EmployeePayrollTips.GET_EMPLOYEE_PAYROLL_TIPS_SUCCESS, response);
export const getEmployeePayrollTipsError = (error: any) => action(EmployeePayrollTips.GET_EMPLOYEE_PAYROLL_TIPS_FAIL, error);
